import React from "react";
import { Row, Col, Card, CardBody, CardTitle, UncontrolledCarousel } from "reactstrap";
import { FaTrophy, FaStar } from "react-icons/fa";
import img1 from "../../assets/images/small/img-4.jpg";
import img2 from "../../assets/images/small/img-5.jpg";
import img3 from "../../assets/images/small/img-6.jpg";

import HighlightCard from "./HighlightCard";
import SpotlightCard from "./SpotlightCard";


const DashboardRow = () => {
    const carouselItems = [
        {
            src: img1,
            altText: "Innovation Award",
            caption: "🏆 SSW Technologies recognized for excellence in R&D innovation.",
            key: 1,
        },
        {
            src: img2,
            altText: "AI Tool Launch",
            caption: "⚙️ Introducing our next-gen Total Hip Extraction System.",
            key: 2,
        },
        {
            src: img3,
            altText: "Team Milestone",
            caption: "🎯 Over 100 engineers now part of the Shukla Medical Group.",
            key: 3,
        },
    ];

    const authData = JSON.parse(sessionStorage.getItem("authUser"));
    const userRole = authData?.role || "Employee";
    console.log("Final UserRole: ", userRole);
    const isEditable = ["Manager", "HR Admin"].includes(userRole);


    const cardHeaderStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "16px",
    };

    const iconCircleStyle = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "34px",
        height: "34px",
        borderRadius: "50%",
        backgroundColor: "#f2f2f2",
        marginRight: "10px",
    };

    const cardStyle = {
        borderRadius: "14px",
        backgroundColor: "#fff",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    };

    return (
        <Row className="mt-3">
            {/* Company Highlights */}
            <Col md="6">
                <HighlightCard role={userRole} />
                {/* <Card className="border-0 shadow-sm" style={cardStyle}>
                    <CardBody style={{ padding: "1.25rem" }}>
                        <div style={cardHeaderStyle}>
                            <div style={iconCircleStyle}>
                                <FaTrophy size={16} color="#ffc107" />
                            </div>
                            <CardTitle tag="h6" className="fw-bold text-dark mb-0">
                                Company Highlights
                            </CardTitle>
                        </div>

                        <div
                            style={{
                                height: "230px",
                                borderRadius: "10px",
                                overflow: "hidden",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                            }}
                        >
                            <UncontrolledCarousel
                                items={carouselItems.map((item) => ({
                                    src: item.src,
                                    altText: item.altText,
                                    caption: "",
                                    header: "",
                                    key: item.key,
                                    // Use "customCaption" instead of "caption"
                                    customCaption: (
                                        <div
                                            style={{
                                                position: "absolute",
                                                bottom: "15px",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                backgroundColor: "rgba(0,0,0,0.55)",
                                                padding: "6px 12px",
                                                borderRadius: "6px",
                                                fontSize: "14px",
                                                color: "#fff",
                                                textAlign: "center",
                                                width: "90%",
                                                maxWidth: "600px",
                                            }}
                                        >
                                            {item.caption}
                                        </div>
                                    ),
                                }))}
                                indicators={false}
                                interval={4000}
                            />

                        </div>
                    </CardBody>
                </Card> */}
            </Col>

            {/* Employee Spotlight */}
            <Col md="6">
                <SpotlightCard role={userRole} />
                {/* <Card className="border-0 shadow-sm" style={cardStyle}>
                    <CardBody
                        style={{
                            padding: "1.25rem",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                        }}
                    >
                        <div style={{ ...cardHeaderStyle, alignSelf: "flex-start" }}>
                            <div style={iconCircleStyle}>
                                <FaStar size={16} color="#ffc107" />
                            </div>
                            <CardTitle tag="h6" className="fw-bold text-dark mb-0">
                                Employee Spotlight
                            </CardTitle>
                        </div>

                        <img
                            src="https://randomuser.me/api/portraits/men/32.jpg"
                            alt="Employee"
                            style={{
                                width: "90px",
                                height: "90px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                marginBottom: "12px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            }}
                        />
                        <h6 className="mb-1 text-dark">Alex Thompson</h6>
                        <small className="text-muted">
                            Engineering Department – Outstanding Innovation Award
                        </small>
                    </CardBody>
                </Card> */}
            </Col>

            {/* Upcoming Events */}

        </Row>
    );
};

export default DashboardRow;
